exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css"), undefined);

// module
exports.push([module.id, ".L632XVbTAhHBX7cCXvZfy{display:block;margin-top:10px;margin-bottom:10px;opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\"}", ""]);

// exports
exports.locals = {
	"help": "L632XVbTAhHBX7cCXvZfy " + require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css").locals["fontSizeNormal"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/help/help.css
// module id = 285
// module chunks = 0 1 2